<section>
  <header class="sx-dialog__content">
    <h2 class="sx-dialog__heading h3">{{ data.header }}</h2>
  </header>
  <div class="sx-dialog__content" [innerHTML]="data.message"></div>
  <div class="sxh-button-footer sxl-align-right sxl-horizontal-stack-small">
    <button class="sx-button sx-button--magenta" mat-button [mat-dialog-close]="true" (click)="onOk()"> {{data.buttonText}}</button>
  </div>
</section>